import * as React from "react";
const IconHospital = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M55.3 20.3 35.7 3.1c-2.1-1.8-5.3-1.8-7.4 0L8.7 20.3c-1.2 1.1-1.9 2.6-1.9 4.2v32.2c0 3.1 2.5 5.6 5.6 5.6H21c3.1 0 5.6-2.5 5.6-5.6V45.5c0-.6.5-1.1 1.1-1.1h8.6c.6 0 1.1.5 1.1 1.1v11.1c0 3.1 2.5 5.6 5.6 5.6h8.6c3.1 0 5.6-2.5 5.6-5.6V24.5c0-1.6-.7-3.2-1.9-4.2m-2.6 36.4c0 .6-.5 1.1-1.1 1.1H43c-.6 0-1.1-.5-1.1-1.1V45.5c0-3.1-2.5-5.6-5.6-5.6h-8.6c-3.1 0-5.6 2.5-5.6 5.6v11.1c0 .6-.5 1.1-1.1 1.1h-8.6c-.6 0-1.1-.5-1.1-1.1V24.5c0-.3.1-.6.4-.8L31.3 6.5c.4-.4 1-.4 1.4 0l19.6 17.1c.2.2.4.5.4.8z" />
    <path d="M37.1 19.5c-1.2 0-2.2 1-2.2 2.2v2.8h-5.7v-2.8c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2V32c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2v-2.8h5.7V32c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2V21.8c0-1.3-1-2.3-2.2-2.3" />
  </svg>
);
export default IconHospital;
